import { useEffect, useState } from 'react';
import { checkAnalyticsCookiesAccepted } from '../utils';

export const useCookieConsent = () => {
  const [hasAnalyticsConsent, setHasAnalyticsConsent] = useState(checkAnalyticsCookiesAccepted());

  useEffect(() => {
    const onAction = () => {
      setHasAnalyticsConsent(checkAnalyticsCookiesAccepted());
    };

    // Add event listener to all elements with the class 'cky-btn' to
    // trigger the consent variables to be set which will update the
    // state/force a re-render when those values change.
    const elements = document.querySelectorAll('.cky-btn');

    for (const element of elements) {
      element.addEventListener('click', onAction);
    }

    return () => {
      for (const element of elements) {
        element.removeEventListener('click', onAction);
      }
    };
  }, []);

  return {
    hasAnalyticsConsent,
  };
};
